export type SyncEffect = {
  id: string;
  type: string;
  payload: any;
  timestamp: string;
};

const SYNC_QUEUE_KEY = 'team-v-does-sync-queue';

export const getSyncQueue = (): SyncEffect[] => {
  try {
    const raw = localStorage.getItem(SYNC_QUEUE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (e) {
    console.error('Failed to load sync queue', e);
    return [];
  }
};

export const saveSyncQueue = (queue: SyncEffect[]) => {
  try {
    localStorage.setItem(SYNC_QUEUE_KEY, JSON.stringify(queue));
  } catch (e) {
    console.error('Failed to save sync queue', e);
  }
};

export const enqueueEffect = (type: string, payload: any) => {
  const queue = getSyncQueue();
  const effect: SyncEffect = {
    id: `sync-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    type,
    payload,
    timestamp: new Date().toISOString(),
  };
  queue.push(effect);
  saveSyncQueue(queue);
  return effect;
};

export const removeEffect = (id: string) => {
  const queue = getSyncQueue();
  const filtered = queue.filter((e) => e.id !== id);
  saveSyncQueue(filtered);
};

export const clearSyncQueue = () => {
  saveSyncQueue([]);
};
